import { combineReducers } from 'redux';

export const makeAllReducer = (asyncReducers) => {
  return combineReducers({ ...asyncReducers });
};


/* eslint-disable no-param-reassign */
export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeAllReducer(store.asyncReducers));
};


export const createReducer = (initialState, ACTION_HANDLERS) => (
  (state = initialState, action) => {
    const handler = ACTION_HANDLERS[action.type];

    return handler ? handler(state, action) : state;
  }
);



// WEBPACK FOOTER //
// ./src/store/reducerUtils.js